import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { HotkeysProvider } from 'react-hotkeys-hook';

import { getEnvironment } from '@cartwhl/common/utils';
import { initDatadog } from '@cartwhl/tracking/datadog';

import { authStore, userStore } from 'stores/global';

import App from './App.tsx';
import './index.css';

authStore.init();
userStore.setTheme('light');
const env = getEnvironment();

initDatadog({
  service: 'applets',
  env,
  isDevelopment: process.env.NODE_ENV === 'development',
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <HotkeysProvider>
      <App />
    </HotkeysProvider>
  </StrictMode>,
);
